import React from 'react';
import { connect } from 'react-redux';
import type ErrorRecord from '~/data/ErrorRecord';
import type { AppState } from '~/reducers';
import { clearError } from './actions';
import UnhandledErrorModalV2 from './components/UnhandledErrorModal/UnhandledErrorModalV2';

interface Props {
  error?: ErrorRecord;
  clearError: typeof clearError;
}

export const UnhandledErrorContainer = (props: Props) => {
  if (!props.error) {
    return null;
  }

  return (
    <UnhandledErrorModalV2
      status={props.error.status}
      description={props.error.description}
      clearError={props.clearError}
    />
  );
};

const mapDispatchToProps = {
  clearError,
};

const mapStateToProps = ({ unhandledError }: AppState) => ({
  error: unhandledError.error,
});

export default connect(mapStateToProps, mapDispatchToProps)(UnhandledErrorContainer);
